module.exports = __webpack_public_path__ + "static/media/react-cover.6ddc15d3.png";